(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__lpdGalleryMore) return;
    window.__lpdGalleryMore = true;

    const desktop = window.matchMedia('(min-width: 1000px)');
    const seen = new WeakSet();

    const visibleItems = (carousel) => Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
    const buttonFor = (carousel) => carousel.closest('product-gallery')?.querySelector('.product-gallery__more');

    function measure(carousel) {
      const button = buttonFor(carousel);
      const items = visibleItems(carousel);
      const expanded = button?.getAttribute('aria-expanded') === 'true';

      if (!desktop.matches || items.length <= 2) {
        carousel.removeAttribute('data-collapsed');
        carousel.style.removeProperty('--lpd-collapsed-height');
        items.forEach((item) => item.removeAttribute('inert'));
        if (button) button.hidden = true;
        return;
      }

      if (button) button.hidden = false;
      if (!expanded) carousel.setAttribute('data-collapsed', '');

      const third = items[2].getBoundingClientRect();
      const height = third.top - carousel.getBoundingClientRect().top + third.height * 0.1;
      if (height > 0) carousel.style.setProperty('--lpd-collapsed-height', Math.round(height) + 'px');

      // Images hidden under the clip should not take keyboard focus
      items.forEach((item, index) => {
        if (!expanded && index >= 2) item.setAttribute('inert', ''); else item.removeAttribute('inert');
      });
    }

    function setup(carousel) {
      if (seen.has(carousel)) return;
      seen.add(carousel);
      const run = () => measure(carousel);
      const resize = new ResizeObserver(run);
      resize.observe(carousel);
      visibleItems(carousel).forEach((item) => resize.observe(item));
      new MutationObserver(run).observe(carousel, { attributes: true, attributeFilter: ['hidden'], subtree: true });
      desktop.addEventListener('change', run);
      run();
    }

    function init() {
      document.querySelectorAll('.product-gallery__carousel[data-collapsible]').forEach(setup);
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.product-gallery__more');
      if (!button) return;
      const carousel = document.getElementById(button.getAttribute('aria-controls'));
      if (!carousel) return;
      const expand = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expand));
      button.textContent = expand ? button.dataset.labelLess : button.dataset.labelMore;
      if (expand) carousel.removeAttribute('data-collapsed');
      measure(carousel);
      if (!expand) {
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = carousel.getBoundingClientRect().top + window.scrollY - header - 16;
        if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
      }
    });

    init();
    document.addEventListener('DOMContentLoaded', init);
    // Variant changes re-render the product block, so pick up any new gallery
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
